export const DateFormatter = (utcDate) => {
    var newDate = new Date(utcDate).toLocaleDateString('en-us', { weekday:"short", year:"numeric", month:"short", day:"numeric"}) 
    return newDate
}